import React, { createContext, useContext, useState, useMemo } from 'react';

const DueDateContext = createContext();

export const useDueDate = () => useContext(DueDateContext);

export const DueDateProvider = ({ children }) => {
	const [dueDateStatus, setDueDateStatus] = useState(null);
	const [remainingDays, setRemainingDays] = useState(null);
	const [reqStatus, setReqStatus] = useState(null);
	const [errorCode, setErrorCode] = useState(null);

	const value = useMemo(
		() => ({
			dueDateStatus,
			setDueDateStatus,
			remainingDays,
			setRemainingDays,
			reqStatus,
			setReqStatus,
			errorCode,
			setErrorCode,
		}),
		[dueDateStatus, remainingDays, reqStatus, errorCode],
	);

	return <DueDateContext.Provider value={value}>{children}</DueDateContext.Provider>;
};
